
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93rt0N6AzWzc6hgEQZy393zy_45SQ_HCc18heLfuDEEbjFMMeta } from "/Users/mile/Projekti/nuxt-base/pages/[...slug].vue?macro=true";
import { default as print_45payment_45transferMoeroUnYHeo86U50TYpjwyXYQRYon6thdmV46sNoCQAMeta } from "/Users/mile/Projekti/nuxt-base/pages/webshop/print-payment-transfer.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/Users/mile/Projekti/nuxt-base/pages/[...slug].vue")
  },
  {
    name: "webshop-print-payment-transfer",
    path: "/webshop/print-payment-transfer",
    meta: print_45payment_45transferMoeroUnYHeo86U50TYpjwyXYQRYon6thdmV46sNoCQAMeta || {},
    component: () => import("/Users/mile/Projekti/nuxt-base/pages/webshop/print-payment-transfer.vue")
  }
]